import { packageLimit } from '@/libs/packageLimits'

/**
 * Menü öğesinin paket limit kontrolünü yapar
 * @param {Object} menuItem - Menü öğesi
 * @returns {boolean} - Menü öğesi gösterilmeli mi
 */
const checkMenuPackageLimit = menuItem => {
  // Eğer packageLimit tanımlı değilse, menü öğesini göster
  if (!menuItem.packageLimit) {
    return true
  }

  const { subject, limit = 1 } = menuItem.packageLimit
  return packageLimit(subject, limit)
}

/**
 * Menü öğelerini paket limit kontrolünden geçirir
 * @param {Array} menuItems - Menü öğeleri array'i
 * @returns {Array} - Filtrelenmiş menü öğeleri
 */
const filterMenuItemsByPackageLimit = menuItems => menuItems.filter(menuItem => {
  // Header öğeleri her zaman gösterilir
  if (menuItem.header) {
    return true
  }

  // Ana menü öğesi için paket limit kontrolü
  if (!checkMenuPackageLimit(menuItem)) {
    return false
  }

  // Alt menü öğeleri varsa, onları da kontrol et
  if (menuItem.children && Array.isArray(menuItem.children)) {
    // eslint-disable-next-line no-param-reassign
    menuItem.children = filterMenuItemsByPackageLimit(menuItem.children)

    // Eğer hiç alt menü kalmadıysa, ana menüyü de gizle
    if (menuItem.children.length === 0) {
      return false
    }
  }

  return true
})

// Tüm menü öğeleri tanımları
const allMenuItems = [
  {
    title: 'nav.dashboard',
    route: 'home',
    icon: 'BarChart2Icon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'nav.projects',
    route: 'Projects',
    icon: 'CropIcon',
    resource: 'PROJECTS_LIST',
    action: 'read',
    packageLimit: {
      subject: 'PROJECTS',
      limit: 1,
    },
  },
  {
    title: 'nav.tasks',
    route: 'Tasks',
    icon: 'CheckSquareIcon',
    resource: 'TASKS_LIST',
    action: 'read',
    packageLimit: {
      subject: 'PROJECTS',
      limit: 1,
    },
  },
  {
    title: 'nav.mySubtasks',
    route: 'MySubtasks',
    icon: 'ListIcon',
    resource: 'APP_DASHBOARD',
    action: 'read',
    packageLimit: {
      subject: 'PROJECTS',
      limit: 1,
    },
  },
  {
    header: 'nav.definitions',
  },
  {
    title: 'nav.departments',
    route: 'Departments',
    icon: 'BoxIcon',
    resource: 'DEPARTMENTS_LIST',
    action: 'read',
  },
  {
    title: 'nav.teams',
    icon: 'UsersIcon',
    route: 'Teams',
    resource: 'TEAMS_LIST',
  },
  {
    header: 'nav.management',
  },
  {
    title: 'nav.system',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'nav.users',
        route: 'Users',
        resource: 'ADMIN_USERS',
        action: 'read',
        packageLimit: {
          subject: 'SUBUSERS_MANAGEMENT',
          limit: 1,
        },
      },
      {
        title: 'nav.userTypes',
        route: 'UserTypes',
        resource: 'all',
        action: 'manage',
        packageLimit: {
          subject: 'SUBUSERS_MANAGEMENT',
          limit: 1,
        },
      },
    ],
  },
]

// Menü öğelerini dinamik olarak oluştur
const getMenuItems = () => filterMenuItemsByPackageLimit(allMenuItems)

// Export both default and named export
export { getMenuItems }
export default getMenuItems()
